/** Single room-creation flow (owner/admin). Link or navigate here from anywhere in the app. */
export const ROOM_CREATE_PATH = '/rooms/new' as const;
